module.exports = __webpack_public_path__ + "img/4.25b249c7.jpg";